// Słownik wspólny: to, co pojawia się w wielu miejscach i nie należy do żadnego ekranu.
//
// Konwencja komentarzy w słownikach:
//   // VERIFY: ...  = tłumaczenie własne, bo mockup nie ma takiego tekstu albo układ się różni.
//                    Do sprawdzenia przez człowieka: `grep -rn "VERIFY" src/i18n`.
//   brak komentarza = tekst wzięty z design/voicesphere-dashboard.html albo oczywisty.
export default {
  // Czasowniki przycisków w trybie rozkazującym, jak w mockupie („Wybierz pliki", „Pokaż więcej").
  actions: {
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    create: 'Utwórz',
    add: 'Dodaj',
    close: 'Zamknij',
    back: 'Wstecz',
    next: 'Dalej',
    confirm: 'Potwierdź',
    search: 'Szukaj',
    submit: 'Wyślij',
    retry: 'Spróbuj ponownie',
    download: 'Pobierz',
    export: 'Eksportuj',
    apply: 'Zastosuj',
    clear: 'Wyczyść',
    showMore: 'Pokaż więcej',
    showLess: 'Pokaż mniej',
    // VERIFY: brak w mockupie (tam jest „Zobacz wszystkie rozmowy →", czyli inny link).
    viewMore: 'Zobacz więcej',
    details: 'Szczegóły',
    ok: 'OK',
  },
  states: {
    loading: 'Ładowanie…',
    noData: 'Brak danych',
    error: 'Coś poszło nie tak',
    all: 'Wszystkie',
    none: 'Brak',
    yes: 'Tak',
    no: 'Nie',
    optional: 'opcjonalne',
    required: 'wymagane',
    // VERIFY: brak w mockupie, tam tylko komunikaty per ekran („Brak rozmów spełniających kryteria.").
    noRecords: 'Brak rekordów do wyświetlenia',
    detecting: 'Wykrywanie…',
  },
  timeRange: {
    // VERIFY: mockup ma „Dziś / 7 dni / 30 dni", a my mamy presety 24h/3d/7d/30d. „24h" to
    // okno kroczące, nie dzień kalendarzowy, więc „Dziś" byłoby nieprawdą.
    '24h': '24 godz.',
    '3d': '3 dni',
    '7d': '7 dni',
    '30d': '30 dni',
    // VERIFY: brak w mockupie.
    '1y': '1 rok',
    custom: 'Własny',
  },
  validation: {
    // VERIFY: brak w mockupie, komunikaty walidacji formularzy.
    emailRequired: 'Podaj adres e-mail',
    emailInvalid: 'To nie jest poprawny adres e-mail',
    passwordRequired: 'Podaj hasło',
  },
  // Mockup pokazuje stempel rozmowy jako „dziś, 09:12" / „wczoraj, 14:38". Godzinę składa
  // `formatConversationDateTime` (utils/helpers), bo zależy od strefy i locale.
  dates: {
    todayAt: 'dziś, {{time}}',
    yesterdayAt: 'wczoraj, {{time}}',
  },
  // VERIFY: cały blok filtrów, brak w mockupie (tam filtry to chipy statusu i lista tematów).
  filters: {
    more: 'Więcej filtrów',
    moreActive: 'Więcej filtrów ({{active}})',
    company: {
      placeholder: 'Firma',
      searching: 'Szukanie…',
      searchUnavailable: 'Wyszukiwanie niedostępne – pokazano wszystkie firmy',
      notFound: 'Nie znaleziono firm',
    },
  },
  rangePicker: {
    // VERIFY: brak w mockupie. Wariant „rok" włącza flaga VITE_ELASTICSEARCH_METRICS_ENABLED.
    maxRangeYear: 'Maksymalny dozwolony zakres dat to 1 rok',
    maxRangeDays: 'Maksymalny dozwolony zakres dat to {{days}} dni',
  },
  loadMore: {
    // VERIFY: cały blok, brak w mockupie (tam przycisk to samo „Pokaż więcej", bez licznika).
    // Licznik to tekst, nie odmiana rzeczownika, więc bez pluralu: „pozostało: 238".
    remaining: 'Pokaż więcej (pozostało: {{remaining}})',
    // Limit wierszy zwraca API; `{{shown}}` to liczba już sformatowana przez `formatNumber`.
    ceiling_one: 'Pokazano pierwszy wiersz. Zawęź filtry, aby zobaczyć więcej.',
    ceiling_few: 'Pokazano pierwsze {{shown}} wiersze. Zawęź filtry, aby zobaczyć więcej.',
    ceiling_many: 'Pokazano pierwsze {{shown}} wierszy. Zawęź filtry, aby zobaczyć więcej.',
    ceiling_other: 'Pokazano pierwsze {{shown}} wiersza. Zawęź filtry, aby zobaczyć więcej.',
  },
  // Etykiety wariantów `StatusBadge` (kolumna Status w Rozmowach).
  statusBadge: {
    ok: 'Rozwiązana przez bota',
    hand: 'Przekazana do urzędnika',
    visit: 'Umówiona wizyta',
    // VERIFY: `live` nie ma odpowiednika w mockupie.
    live: 'W toku',
    // VERIFY: `idle` i `fail` nie mają odpowiednika w mockupie; sekcja połączeń wychodzących
    // podaje własną etykietę, to tylko domyślne brzmienie.
    idle: 'Nieaktywny',
    fail: 'Błąd',
  },
  // VERIFY: cały blok, brak w mockupie (mockup nie ma chipów statusu z ikoną).
  statusChip: {
    info: 'Informacja',
    warning: 'Ostrzeżenie',
    error: 'Błąd',
    success: 'Sukces',
    resolved: 'Rozwiązane',
    unresolved: 'Nierozwiązane',
    live: 'Na żywo',
  },
  // Rola użytkownika jako podpis pod nazwą (mockup: „administrator", małą literą).
  roles: {
    admin: 'administrator',
    // VERIFY: pozostałe role, mockup ma tylko „administrator".
    company_admin: 'administrator firmy',
    user: 'użytkownik',
    reviewer: 'recenzent',
    call_taker: 'operator połączeń',
  },
  // VERIFY: cały blok, brak w mockupie. Etykiety przełącznika `CustomSwitch`; kluczem jest
  // wartość opcji (`Calls`, `SMS`, `Live`, `History`), która zostaje angielska w logice.
  switch: {
    Calls: 'Rozmowy',
    SMS: 'SMS',
    Live: 'Na żywo',
    History: 'Historia',
  },
} as const;
